/**
 * bundle.js — DEMO "Mua kèm thường xuyên" ở trang chi tiết sản phẩm.
 *
 * Markup: [data-bundle] chứa
 *           input[data-bundle-item][data-product-id][data-price][data-regular-price]
 *             (thêm [data-bundle-main] cho chai đang xem — luôn tick, disabled)
 *           [data-bundle-total] · [data-bundle-regular] (+ del[data-bundle-regular-wrap])
 *           [data-bundle-count] (có thể nhiều chỗ) · [data-bundle-ship] · button[data-bundle-add]
 *
 * Vì sao:
 *   · Chai đang xem đi theo dung tích đang chọn ở form mua (input[name="variant"]:checked trong
 *     [data-pdp-form]) — đổi 375ml / Magnum thì giá trong combo đổi theo, khớp thẻ "Đang xem"
 *     (js/pdp.js đã cập nhật [data-pdp-price] / [data-pdp-variant-label] trong thẻ).
 *   · Dòng "miễn phí giao hàng" chỉ hiện khi tổng ≥ 2.000.000₫ — đúng ngưỡng ở thanh trên cùng
 *     và trang Câu hỏi thường gặp.
 *   · Thêm giỏ qua window.WBStore (store.js nạp SAU file này — gọi lúc bấm), mỗi món một dòng.
 *
 * WP: XOÁ file này. Nút gọi AJAX woocommerce_add_to_cart cho từng id (hoặc plugin bundle),
 * tổng tiền in bằng PHP; giữ nguyên class / data-* để CSS không đổi.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var FREE_SHIP = 2000000;
    var root = document.querySelector('[data-bundle]');
    if (!root) return;

    var inputs = [].slice.call(root.querySelectorAll('[data-bundle-item]'));
    var button = root.querySelector('[data-bundle-add]');
    var form = document.querySelector('[data-pdp-form]');

    function money(value) {
        if (window.WBStore) return window.WBStore.money(value);
        return Math.round(Number(value) || 0).toLocaleString('vi-VN') + '₫';
    }

    function each(selector, fn) {
        [].slice.call(root.querySelectorAll(selector)).forEach(fn);
    }

    // Chai đang xem: giá theo dung tích đang chọn; phụ kiện: giá in sẵn trên input
    function priceOf(input) {
        var variant = input.hasAttribute('data-bundle-main') && form ? form.querySelector('input[name="variant"]:checked') : null;
        var source = variant || input;
        var price = Number(source.getAttribute('data-price')) || 0;
        var regular = Number(source.getAttribute('data-regular-price')) || price;
        return { price: price, regular: Math.max(regular, price), variant: variant ? variant.value : '' };
    }

    function render() {
        var total = 0;
        var regular = 0;
        var count = 0;
        inputs.forEach(function (input) {
            if (!input.checked) return;
            var p = priceOf(input);
            total += p.price;
            regular += p.regular;
            count += 1;
        });

        each('[data-bundle-total]', function (el) {
            el.textContent = money(total);
        });
        each('[data-bundle-regular]', function (el) {
            el.textContent = money(regular);
        });
        each('[data-bundle-regular-wrap]', function (el) {
            el.hidden = regular <= total;
        });
        each('[data-bundle-count]', function (el) {
            el.textContent = count;
        });
        each('[data-bundle-ship]', function (el) {
            el.hidden = total < FREE_SHIP;
        });
        if (button) button.disabled = count === 0;
    }

    root.addEventListener('change', function (event) {
        if (event.target.hasAttribute('data-bundle-item')) render();
    });

    // Đổi dung tích ở form mua → giá chai trong combo đổi theo
    if (form) {
        form.addEventListener('change', function (event) {
            if (event.target.name === 'variant') render();
        });
    }

    if (button) {
        button.addEventListener('click', function () {
            if (!window.WBStore) return;
            var added = 0;
            inputs.forEach(function (input) {
                if (!input.checked) return;
                var snap = window.WBStore.product(input.getAttribute('data-product-id'), input);
                if (!snap) return;
                var p = priceOf(input);
                snap.price = p.price;
                snap.regularPrice = p.regular;
                if (p.variant) snap.variant = p.variant;
                window.WBStore.cart.add(snap, 1);
                added += 1;
            });
            if (added && window.WBToast) window.WBToast.show('Đã thêm ' + added + ' món vào giỏ hàng');
        });
    }

    render();
})();
